import './Styles.scss'
import { isSeznamUser } from './js/SeznamUserDetect'
import { isEconomiaUser } from './js/EconomiaUserDetect'
import { init as mobilePopup } from './js/MobilePopup'
import { init as initSeznamAds, repeaterAd as seznamRepeaterAd, loadSeznamAds, setBranding as setSeznamBranding, onloadSeznamSsp } from './js/SeznamAds'
import { init as initGoogleAds, onloadCallback as onloadGoogleAds } from './js/GoogleAds'
import { init as initProtagAds, onloadCallback as onloadProtagAds } from './js/ProtagAds'
import { init as initPerfomaxAds, placePXBranding as placePXBranding } from './js/Perfomax'
import './js/SeznamRecommendBox'

const initAds = () => {
	initSeznamAds()

	if (!isSeznamUser()) {
		if (location.hostname !== 'www.funnygardening.com') {
			initGoogleAds()
		}
		if (window.themeConfig.protagWebId) {
			initProtagAds()
		}
		initPerfomaxAds()
	}
}

document.addEventListener('DOMContentLoaded', function () {
	initAds()
})

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('a[href="#cmp"]').forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()

			scmp.open()
		})
	})
})

export { onloadProtagAds, onloadGoogleAds, seznamRepeaterAd, mobilePopup, loadSeznamAds, setSeznamBranding, onloadSeznamSsp, placePXBranding }
